import * as React from 'react'

/*
 * Sets the document title to the page's `h1` text while the page is shown,
 * and restores the previous title when it goes (WCAG 2.4.2). `null` leaves
 * the title alone, for a component that is not always the page heading.
 */
export function usePageTitle(title: string | null) {
  React.useEffect(() => {
    if (title === null) return
    const previous = document.title
    document.title = title
    return () => {
      document.title = previous
    }
  }, [title])
}
